import { scheduleData } from "../config/siteData";

const Schedule = () => {
  return (
    <section id="schedule" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Tuesday <span className="text-purple-400">Schedule</span>
          </h2>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
            <div className="bg-purple-600 text-white p-6">
              <h3 className="text-2xl font-bold text-center">Weekly Class Schedule</h3>
            </div>
            
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-6 py-4 text-left text-lg font-semibold text-gray-900">Time</th>
                    <th className="px-6 py-4 text-left text-lg font-semibold text-gray-900">Class</th>
                    <th className="px-6 py-4 text-left text-lg font-semibold text-gray-900">Age Group</th>
                  </tr>
                </thead>
                <tbody>
                  {scheduleData.map((item, index) => (
                    <tr key={index} className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-purple-50 transition-colors`}>
                      <td className="px-6 py-4 text-gray-900 font-semibold">{item.time}</td>
                      <td className="px-6 py-4 text-purple-600 font-semibold">{item.class}</td>
                      <td className="px-6 py-4 text-gray-700">{item.ageGroup}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div className="bg-teal-50 p-6 text-center border-t">
              <p className="text-teal-800 font-semibold text-lg">
                Registration and payment options below.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;